/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

'use strict';

var _require = require('./ReactElement'),
    isValidElement = _require.isValidElement;

var factory = require('prop-types/factory');

module.exports = factory(isValidElement);


/*****************
 ** WEBPACK FOOTER
 ** ./~/react/lib/ReactPropTypes.js
 ** module id = 105
 ** module chunks = 35
 **/